// extracted by mini-css-extract-plugin
module.exports = {"LogoList":"LogoList_LogoList__0Mdfw","ImageWrapper":"LogoList_ImageWrapper__xAXBf","Image":"LogoList_Image__Qhrkx"};